import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Popover } from 'react-bootstrap';
import classnames from 'classnames';
import TooltipBody from './components/TooltipBody';

const ElementWithTooltip = ({
    children,
    className,
    displayEvent,
    placement,
    showByDefault,
    showCloseButton,
    size,
    targetElement,
    targetClassName,
    tertiaryBtn,
    tooltipId,
}) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const targetElementRef = useRef(null);

  useEffect(() => {
    // When the tooltip needs to be displayed by default,
    // this positions the tooltip correctly on the target element
    // Done when the targetElementRef is set after the component is mounted.
    setShow(showByDefault);
    setTarget(targetElementRef.current);
  }, [targetElementRef]);

  const toggleTooltip = (event) => {
    const {
      type,
    } = event;
    const clickEvent = type === 'click' && displayEvent === 'click';
    const hoverEvent = (type === 'mouseenter' || type === 'mouseleave') && displayEvent === 'hover';

    if (clickEvent || hoverEvent) {
      setShow(!show);
    }
  };

  const closeTooltip = () => {
    setShow(false);
  };

  const tooltipClasses = classnames(
    'ds-tooltip',
    `ds-tooltip-${size}`,
    className,
  );

  const targetClasses = classnames(
    'ds-tooltip-target',
    targetClassName,
  );

  return (
    <div className="ds-tooltip-wrapper">
      <div
        className={targetClasses}
        onClick={toggleTooltip}
        onMouseEnter={toggleTooltip}
        onMouseLeave={toggleTooltip}
        ref={targetElementRef}
      >
        {targetElement}
      </div>
      <Overlay
        show={show}
        target={target}
        placement={placement}
      >
        <Popover
          id={tooltipId}
          className={tooltipClasses}
        >
          <TooltipBody
            closeTooltipOnClick={closeTooltip}
            showCloseButton={showCloseButton}
            tertiaryBtn={tertiaryBtn}
          >
            {children}
          </TooltipBody>
        </Popover>
      </Overlay>
    </div>
  );
};


ElementWithTooltip.defaultProps = {
  children: null,
  className: '',
  displayEvent: 'hover',
  placement: 'bottom',
  showByDefault: false,
  showCloseButton: false,
  size: 'sm',
  targetClassName: '',
  tertiaryBtn: null,
};

ElementWithTooltip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  displayEvent: PropTypes.oneOf([
    'click',
    'hover',
    'none',
  ]),
  placement: PropTypes.oneOf([
    'bottom',
    'left',
    'right',
    'top',
  ]),
  showByDefault: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  size: PropTypes.oneOf([
    'sm',
    'md',
    'lg',
  ]),
  targetElement: PropTypes.node.isRequired,
  targetClassName: PropTypes.string,
  tertiaryBtn: PropTypes.shape({
    className: PropTypes.string,
    copy: PropTypes.string,
    enableCloseTooltip: PropTypes.bool,
    onClick: PropTypes.func,
  }),
  tooltipId: PropTypes.string.isRequired,
};

export default ElementWithTooltip;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Tooltips/ElementWithTooltip.jsx